/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2023 Karmabunny
 */
import { API } from "./base";
import { Deal } from "../types";


const api = new API();


/**
 * Hits the `#[Route('{uid}/deals')]` in the Explore controller in TheyStay/API returning
 * a list of deals.
 */
export async function getDeals(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/explore/${entity_uid}/deals`,
    })

    return res.items as Deal[];
}


/**
 * Hits the `#[Route('{entity_uid}/deals/{attraction_uid}')]` in the Explore controller in
 * TheyStay/API returning a single deal
 */
export async function getDeal(deal_uid: string, entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/explore/${entity_uid}/deals/${deal_uid}`,
    })

    return res as Deal;
}
